export default "__VITE_ASSET__DD1Gtt8T__"